import { Box, Button, Divider, Modal, Paper, Stack } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addActiveClass, bottomPosition, customStyles } from '../../../styles'
import { setFullTextDate } from '../../../utils/setDateNames'
import { MainContainer } from '../../containers'
import { CaptionText, MainButton, MainInput, MainSelect, RegularText, SmallText, SubTitle, UnderlineText } from '../../helpers'
import { ModalHeader } from '../../modals'
import { MapFollow } from './MapFollow'
import { OrderSteps } from './OrderSteps'
import { ProductOrder } from './ProductOrder'
import { ServiceInfo } from './ServiceInfo'
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { useOpenComponent } from '../../../hooks/useOpenComponent'
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import { Map } from '../address/Map'
import { JustMap } from './JustMap'
import { deleteServiceAction } from '../../../actions/deleteServiceAction'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { useCustomForm } from '../../../hooks/useCustomForm'
import { Navigate, useNavigate } from 'react-router-dom'
import { setError } from '../../../slices/statusSlice'
import { animations } from '../../../utils/animations'
import { useEffect } from 'react'
import { resetCause } from '../../../slices/causesSlice'
import { setAccount } from '../../../slices/orderSlice'
import { TruckAnimation } from '../../animated/TruckAnimation'
import { getProducts } from '../../../actions'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 5
};

export const TrackOrder = React.forwardRef(( props, ref) => {
  const { trackingOrder } = useSelector(state => state.order);
  const { causes, idCause } = useSelector(state => state.causes);
  const [authorization] = useLocalStorage('login-token', null)
  const { isOpen, handleIsOpen } = useOpenComponent()
  const [openModal, setOpenModal] = useState(false)
  const { inputValues, handleOnChange } = useCustomForm({ observations: '' })
  const { observations } = inputValues
  const { date, status, type, start, end, total, account, justRead } = trackingOrder !== null && trackingOrder;
  const { street, colony,  postalCode, longitude, latitude, extNumber, alias, id} = account !== undefined && account
  // const {} = customStyles
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handleDeleteService = () => {
    if(idCause) {
      const newForm = {
        idCause, observations
      }
      dispatch(deleteServiceAction(trackingOrder?.id, newForm, authorization?.token))
      setOpenModal(false)
      navigate('/dashboard/content')
    } else {
      dispatch(setError({ message: 'Ninguna causa seleccionada', code: 0 }))
    }
  }

  const handleNavigate = () => {
    dispatch(setAccount(account))
    navigate(`/dashboard/${id}/${type.toLowerCase()}`)
    dispatch(getProducts(id, authorization?.token))
  }
  const backward = () => {
    navigate(-1)
  }

  const linkOutside = () => {
    navigate('https://verseqa.globalgas.com.mx:8001/')
  }

  useEffect(() => {
    dispatch(resetCause())
    !trackingOrder && navigate('/dashboard/content')
  }, [])
  return (
    <>
    {
      trackingOrder && 
      <MainContainer sx={{backgroundColor: customStyles.colors.backgroundColor}}>
      { justRead && <ModalHeader text="Pedido de gas" color={ customStyles.colors.main } backward action={backward} help={true}/> }
      {
        !justRead &&
        <>
          <ModalHeader text="Pedido agendado" color={ customStyles.colors.main } backward={false} help={true}/>
          <TruckAnimation />
          <RegularText text={`Tu servicio llegará a tu dirección el ${setFullTextDate(date)} de ${start} - ${end}`}/>
          <OrderSteps status={status}/>
          <Divider sx={{margin: '30px 0'}}/>
        </>
      }

      <SubTitle text="Información del pedido"/>
      {/* {
        !justRead &&
        <Stack direction="row" justifyContent="space-between">
          <SubTitle text="Información del pedido"/>
          {
            !isOpen
            ? <KeyboardArrowDownRoundedIcon sx={{ color: customStyles.colors.secondary, cursor: 'pointer', ...addActiveClass }} onClick={handleIsOpen}/>
            : <KeyboardArrowUpRoundedIcon sx={{ color: customStyles.colors.secondary, cursor: 'pointer', ...addActiveClass }} onClick={handleIsOpen}/>

          }
        </Stack>
      } */}
      {/* {
        isOpen &&  <ServiceInfo />
      } */}
      <ServiceInfo />
      <Paper>
      <Map readOnly/>
      {/* <Box className={isOpen && animations.shake} sx={{transition: '.3s linear'}}>

      </Box> */}
      </Paper>
      {/* <JustMap /> */}
      <Stack  spacing={1}  alignItems="center" direction="row" mt={3} justifyContent="end">
        {/* <MainButton text="Seguir mi servicio" size="40%" variant="outlined"/> */}
        {
          justRead
           ?
           <>
            { status === 'DONE' && <MainButton text="Facturar" size="50%" variant="outlined" link="https://factura.globalgas.mx/"/> }
             
             <MainButton text="Volver a pedir" size="50%" variant="contained" onClick={handleNavigate} />
           </>  
           : 
           <>
            <MainButton text="Volver al Inicio" size="50%" variant="outlined" onClick={backward}/>
            <MainButton text="Cancelar pedido" size="50%" color="error" variant="contained" onClick={() => setOpenModal(true)}/>
           </>
        }
      </Stack>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className={animations.fadeIn}
      >
        <Stack sx={style}>
          <RegularText text="Estas seguro que deseas eliminar el pedido?"  sx={{fontSize: 20, marginBottom: 3}}/>
          <MainSelect data={causes} text="Seleccione una causa" />
          {/* <RegularText text="Desea agregar alguna observación?"  sx={{fontSize: 20, marginTop: 3}}/>
          <MainInput name="observations" value={observations} onChange={handleOnChange} multiline height="auto"/> */}
          <Divider sx={{margin: '20px 0'}}/>
          <CaptionText text="Recuerda que algunas cancelaciones pueden tener un costo de hasta $100 pesos." align="center" color={customStyles.colors.lightColor}/>
          <Stack direction="row" justifyContent="space-between">
            <MainButton text="Cancelar" size="40%" variant="outlined" onClick={() => setOpenModal(false)}/>
            <MainButton text="Confirmar" size="40%" variant="contained" onClick={handleDeleteService}/>
          </Stack>
        </Stack>
      </Modal>
    </MainContainer>

    }
    </>
      )
})
